import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MyDistricts from '../../components/districts/mydistricts';
import Details from '../../components/districts/details';
import Scenarios from '../../components/scenarios';
import './styles.scss';

const Districts = props => {
    
    const [isOpen, toggleScenario] = useState(false);
    
    const shouldReloadView = (open) => {
        if (!open) {
            window.location.href = '/scenario';
        } else {
            toggleScenario(true);
        }
    };

    return (
        <Router>
            <section className="districts">
                    <Switch>
                        <Route path={['/foodservice-districts', '/foodservice-scenario/:scenarioId', '/foodservice-scenario']} exact={true}>
                            <MyDistricts type="foodservice"  heading="Mina säljdistrikt foodservice" toggleScenario={(open) => shouldReloadView(open)} isScenarioOpen={isOpen}   />
                            <Scenarios type="foodservice" isOpen={isOpen} toggleTakeover={() => shouldReloadView(false)}  />
                        </Route>

                        <Route path={['/districts', '/scenario/:scenarioId', '/scenario']} exact={true}>
                            <MyDistricts type="livs" heading="Mina distrikt" toggleScenario={(open) => shouldReloadView(open)} isScenarioOpen={isOpen} />
                            <Scenarios type="livs" isOpen={isOpen} toggleTakeover={() => shouldReloadView(false)}  />
                        </Route>

                        <Route path={['/districts/:id', '/scenario/:scenarioId/district/:id']} exact={true}>
                            <Details type="livs" />
                        </Route>

                        <Route path={['/foodservice-scenario/:id', '/foodservice-scenario/:scenarioId/district/:id']} exact={true}>
                            <Details type="foodservice" />
                        </Route>
                    </Switch>
            </section>
        </Router>
    );
};

export default withRouter(Districts);